import { TIconProps } from './utils';

export const MenuFavoriteIcon = ({ className = '' }: TIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='32'
    height='27'
    viewBox='0 0 32 27'
    fill='none'
    className={className}
  >
    <path
      d='M17.471 25.3164C19.2988 24.2232 23.4548 21.5644 26.6648 18.1849C28.2689 16.4962 29.6906 14.5722 30.4398 12.5203C31.1998 10.4387 31.2709 8.20397 30.1241 6.01593C29.1986 4.24998 28.0797 3.05891 26.8198 2.35458C25.555 1.64761 24.229 1.47639 22.973 1.61436C20.5162 1.88423 18.2567 3.3433 16.8885 4.40353C16.3739 4.80232 15.6075 4.81139 15.0976 4.43412C13.6409 3.35627 11.2134 1.8316 8.68262 1.52339C7.38914 1.36587 6.02613 1.52118 4.76337 2.25514C3.50198 2.98832 2.44382 4.23891 1.64924 6.08473C-0.282184 10.5715 2.3888 14.9742 5.5187 18.2616C8.71447 21.6182 12.7697 24.2301 14.57 25.313C15.4702 25.8544 16.5699 25.8554 17.471 25.3164Z'
      stroke='black'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
